import { render, staticRenderFns } from "./CompanyTrusteeListItem.vue?vue&type=template&id=4d4cfb90"
import script from "./CompanyTrusteeListItem.vue?vue&type=script&lang=js"
export * from "./CompanyTrusteeListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports